module.exports = __webpack_public_path__ + "img/coulrophobia.91020a1e.png";